import { bpmRuntimeExecutionService, BpmRuntimeExecutionService } from "@edp-bpm/universal-runtime-api";
import { BpmRuntimeDevkitService } from "./bpm-runtime-devkit/bpm-runtime-devkit.service";
import { Provider } from "@angular/core";
import { BpmRuntimeDevkitWebCmpService } from "./webcmp/bpm-runtime-devkit.webmp.service";

const BPM_RUNTIME_DEVKIT_PROVIDERS: Provider[] = [
    { provide: BpmRuntimeExecutionService, useValue: bpmRuntimeExecutionService },
    BpmRuntimeDevkitService,
    BpmRuntimeDevkitWebCmpService,
];

const BPM_DEVKIT_PROVIDERS: Provider[] = [
    ...BPM_RUNTIME_DEVKIT_PROVIDERS,
];

export { BPM_RUNTIME_DEVKIT_PROVIDERS };
export { BPM_DEVKIT_PROVIDERS };